<template>
	<div class="home">
		<div class="homeHeader">
			<div class="container">
				<nav class="navbar navbar-default">
					<div class="container-fluid">
						<!-- Brand and toggle get grouped for better mobile display -->
						<div class="navbar-homeHeader col-lg-4 col-md-3 col-sm-5">
							<!-- 							<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"
							 aria-expanded="false">
								<span class="sr-only">Toggle navigation</span>
								<span class="icon-bar"></span>
								<span class="icon-bar"></span>
								<span class="icon-bar registerBtn"></span>
							</button> -->
							<a href="http://www.fengtaoit.com/">
								<img src="../../static/images/homeLogo.png">
							</a>
						</div>

						<!-- Collect the nav links, forms, and other content for toggling -->
						<div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
							<ul class="nav navbar-nav col-lg-8 col-md-9 col-sm-7">
								<li class="col-lg-2 listTitle"><a @click="scollTo('banner-pattern')">功能介绍</a></li>
								<li class="col-lg-2 listTitle"><a @click="scollTo('freeTrialBox')">服务价格</a></li>
								<li class="col-lg-2 listTitle"><a @click="scollTo('aboutUs')">关于我们</a></li>
								<li class="hidden-xs  hidden-sm col-lg-1 btnBox" v-if="userVo">{{userVo}}</li>
								<li class="hidden-xs  hidden-sm col-lg-1 btnBox" v-if="userVo" style="width: 100px;">
									<a class="login-Btn Btn" href="http://app.fengtaoxx.com/steel-user/" style="width: 100px;">管理后台</a>
								</li>
								<li class="hidden-xs  hidden-sm col-lg-1 btnBox" v-if="!userVo">
									<a class="login-Btn Btn" href="http://app.fengtaoxx.com/steel-user/toLogin">登录</a>
								</li>
								<li class="hidden-xs  hidden-sm col-lg-1 btnBox" v-if="!userVo">
									<a class="register-Btn Btn" href="http://app.fengtaoxx.com/steel-user/toRegister">注册</a>
								</li>
								<li class="hidden-md hidden-xs  hidden-sm col-lg-3 phoneBox"><span class="phone">020-29815512</span></li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		</div>
		<div class="banner">
			<div class="banner-bg">
				<!--<img src="../../static/images/banner1.jpg" />-->
				<div>
					<swiper :options="swiperOption" class="swiperOption" ref="mySwiper">
					    <swiper-slide><img src="../../static/images/banner1.jpg" /></swiper-slide>
					    <!-- <swiper-slide><img src="../../static/images/banner2.jpg" /></swiper-slide>
					    <swiper-slide><img src="../../static/images/banner3.jpg" /></swiper-slide>
					    <swiper-slide><img src="../../static/images/banner4.jpg" /></swiper-slide> -->
					    <div class="swiper-pagination"  slot="pagination"></div>
					    <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
					</swiper>
				</div>
				<div class="banner-footer">
					<div class="container">
						<div class="con-item">
							<span class="con-item-num blue con-item-num1">{{conItemNum1}}</span>
							<span class="blue add">+</span>
							<span class="con-item-text">/ 商家入驻数</span>
						</div>
						<div class="con-item">
							<span class="con-item-num green con-item-num2">{{conItemNum2}}</span>
							<span class="green add">+</span>
							<span class="con-item-text">/ 用户总数</span>
						</div>
						<!--<div class="con-item">
							<span class="con-item-num red con-item-num3">{{conItemNum3}}</span>
							<span class="red add">+</span>
							<span class="con-item-text">/ 服务企业</span>
						</div>-->
					</div>
				</div>
			</div>
		</div>
		<div class="banner-function">
			<div class="con">
				<div class="b-f-con">
					<p class="title">专注解决钢铁批发贸易公司开单、入库、结算难问题，帮助企业节能减排，提高企业经济效益</p>
					<p class="title2">适用于各类经营模式企业(批发、批零兼营、零售、连锁加盟、渠道分销)</p>
					<div class="functionBox">
						<div class="function-item">
							<img src="../../static/images/icon/functionIcon1.png">
							<span>批发型</span>
						</div>
						<div class="function-item">
							<img src="../../static/images/icon/functionIcon2.png">
							<span>批零兼售型</span>
						</div>
						<div class="function-item">
							<img src="../../static/images/icon/functionIcon3.png">
							<span>零售型</span>
						</div>
						<div class="function-item">
							<img src="../../static/images/icon/functionIcon4.png">
							<span>连锁加盟、渠道分销型</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="banner-do">
			<div class="con">
				<p class="title">我们能为你做什么?</p>
				<p class="title2">"人" "钱" "业务" 三点要素的信息化管理</p>
				<div class="doBox">
					<div class="do-item">
						<div class="top">
							<img src="../../static/images/doItemBg1.png" />
						</div>
						<div class="bottom">
							<p class="title">高效，成就卓越团队</p>
							<p class="title2">
								每个业务环节都能始终保持畅通，无论是做了10年的老员工
								还是薪员工，都能轻松处理业务；销售人员的管理也变得轻而易举，
								只需要掏出手机，就能掌握客户跟进动态。
							</p>
						</div>
					</div>
					<div class="do-item">
						<div class="top">
							<img src="../../static/images/doItemBg2.png" />
						</div>
						<div class="bottom">
							<p class="title">精益求精，财务尽在掌握</p>
							<p class="title2">
								轻点一下，呈现最准确的各类报表，一键拉取，历史数据一览无余；
								资金点滴汇入，每一笔走向都清晰明了，高效的财务工作，催生更大
								回报的资金决策。
							</p>
						</div>
					</div>
					<div class="do-item">
						<div class="top">
							<img src="../../static/images/doItemBg3.png" />
						</div>
						<div class="bottom">
							<p class="title">智能响应，引领业务未来</p>
							<p class="title2">
								对货品存量了若指掌，第一时间影响订单，同时，多余的资金
								也得到释放；销售报表一目了然，让营销方案有据可依，与供应商的议价
								也变得容易起来，为企业创造更大的利润。
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="banner-pattern" id="banner-pattern">
			<div class="con">
				<p class="title">用互联网技术改变传统工作模式让企业经营管理更高效</p>
				<img src="../../static/images/bannerPatternBg.jpg" />

				<div class="freeTrialBox" id="freeTrialBox">
					<a href="http://app.fengtaoxx.com/steel-user/toRegister">
						<span>免费试用</span>
						<img src="../../static/images/icon/freeTrialIcon.png" />
					</a>
				</div>
        <div class="payUserBox">
          <p>按用户计费,518/年 一个账户</p>
        </div>
				<div class="payItemBox" v-if="vipGoodsList.length > 0">
					<!-- <back></back> -->
					<div  class="payItem item1" v-for="(item,index) in vipGoodsList" :key="item.id" @click="goPay('http://app.fengtaoxx.com/steel-user/index?type='+(index+1))">
						<div class="payMessage">
							<span class="paySymbol">￥</span>
							<span class="payPrice">{{item.price}}</span>
							<span class="paySymbol">元 / {{item.name}}</span>
						</div>
						<p>{{item.content}}</p>
						<div class="payBtn payBtn1"><a :href="'http://app.fengtaoxx.com/steel-user/index?type='+(index+1)">去支付</a></div>
					</div>
					<!-- <div class="payItem item2" @click="goPay('http://app.fengtaoxx.com/steel-user/index?type=2')">
						<div class="payMessage">
							<span class="paySymbol">￥</span>
							<span class="payPrice">5999</span>
							<span class="paySymbol">元 / 2年</span>
						</div>
						<p>送价值1999元12寸平电脑<br/>(默认10个账户)</p>
						<div class="payBtn payBtn2"><a href="http://app.fengtaoxx.com/steel-user/index?type=2">去支付</a></div>
					</div>
					<div class="payItem item3" @click="goPay('http://app.fengtaoxx.com/steel-user/index?type=3')">
						<div class="payMessage">
							<span class="paySymbol">￥</span>
							<span class="payPrice">7999</span>
							<span class="paySymbol">元 / 3年</span>
						</div>
						<p>送价值3999元55寸智能液晶电视<br/>(默认10个账户)</p>
						<div class="payBtn payBtn3"><a href="http://app.fengtaoxx.com/steel-user/index?type=3">去支付</a></div>
					</div> -->
				</div>
			</div>
		</div>
		<div class="banner-more">
			<!-- <div class="moreBox">
				<span>了解更多</span>
				<img src="../../static/images/icon/goMoreIcon.png" />
			</div> -->
		</div>
		<div class="banner-port">
			<div class="con">
				<p class="title">多端匹配，契合用户使用习惯</p>
				<p class="title1"><span>方便用户</span><span>留住客户</span><span>营销客户</span></p>
				<div class="portItemBox">
					<div class="portItem portItemOn" @click="showR()">
						<img src="../../static/images/icon/portItemIcon1.png" class="portItemOnimg1"/>
						<img src="../../static/images/icon/gh_d6cd78832555_258.jpg" class="portItemOnimg2"/>
						<span>小程序</span>
					</div>
					<a class="portItem" href="http://app.fengtaoxx.com/steel-user/toLogin" >
						<img src="../../static/images/icon/portItemIcon2.png" />
						<span>PC端</span>
					</a>
					<div class="portItem">
						<img src="../../static/images/icon/portItemIcon3.png" />
						<span>APP端</span>
					</div>
					<div class="portItem">
						<img src="../../static/images/icon/portItemIcon4.png" />
						<span>微信端</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="banner-news">
			<div class="con">
				<p class="title">新闻资讯</p>
				<ul>
					<li>
						<div class="left">
							<span class="date">04-10</span>
							<span class="year">2019</span>
						</div>
						<div class="right">
							<p class="new-title">
								<span class="hotIcon">
									<img src="../../static/images/icon/newsHotIcon.png" />
								</span>
								库存管理系统能为企业库存管理提供什么价值？
							</p>
							<p class="new-content">
								库存管理，广义上是指对企业一切有价值的资产进行管理，包括
								原物料、半成品、成品、土地、人力、时间等。但目前很多企业还是
							</p>
						</div>
					</li>
					<li>
						<div class="left">
							<span class="date">04-10</span>
							<span class="year">2019</span>
						</div>
						<div class="right">
							<p class="new-title">
								<span class="hotIcon">
									<img />
								</span>
								库存管理系统能为企业库存管理提供什么价值？
							</p>
							<p class="new-content">
								库存管理，广义上是指对企业一切有价值的资产进行管理，包括
								原物料、半成品、成品、土地、人力、时间等。但目前很多企业还是
							</p>
						</div>
					</li>
					<li>
						<div class="left">
							<span class="date">04-10</span>
							<span class="year">2019</span>
						</div>
						<div class="right">
							<p class="new-title">
								<span class="hotIcon">
									<img />
								</span>
								库存管理系统能为企业库存管理提供什么价值？
							</p>
							<p class="new-content">
								库存管理，广义上是指对企业一切有价值的资产进行管理，包括
								原物料、半成品、成品、土地、人力、时间等。但目前很多企业还是
							</p>
						</div>
					</li>
					<li>
						<div class="left">
							<span class="date">04-10</span>
							<span class="year">2019</span>
						</div>
						<div class="right">
							<p class="new-title">
								<span class="hotIcon">
									<img />
								</span>
								库存管理系统能为企业库存管理提供什么价值？
							</p>
							<p class="new-content">
								库存管理，广义上是指对企业一切有价值的资产进行管理，包括
								原物料、半成品、成品、土地、人力、时间等。但目前很多企业还是
							</p>
						</div>
					</li>
					<li>
						<div class="left">
							<span class="date">04-10</span>
							<span class="year">2019</span>
						</div>
						<div class="right">
							<p class="new-title">
								<span class="hotIcon">
									<img />
								</span>
								库存管理系统能为企业库存管理提供什么价值？
							</p>
							<p class="new-content">
								库存管理，广义上是指对企业一切有价值的资产进行管理，包括
								原物料、半成品、成品、土地、人力、时间等。但目前很多企业还是
							</p>
						</div>
					</li>
				</ul>
			</div>
		</div> -->

		<div class="footer-we" id="aboutUs">
			<div class="con">
				<div class="top">
					<div class="left">
						<p class="title">关于我们 <span>/ About Us</span></p>
						<p class="content">
							 广州蜂陶信息技术有限公司（简称“蜂陶信息”）是一家集软、硬件产品研发销售于一体的高新技术企业。致力于成为智慧安全出行解决方案、智慧农产品安全追溯解决方案、智慧安全巡检解决方案专家。蜂陶信息软、硬件产品广泛应用航空、交通运输、教育、医疗、物流、制造业、农业等行业。
						</p>
						<p class="content">
							 蜂 -- 勤劳、敬业、专注、刚毅，不畏艰难勇往直前。
						</p>
						<p class="content">
							 陶 -- 快乐、教育、培养、熏陶，分享成果授人以渔。
						</p>
					</div>
					<div class="right">
						<div class="con-left">
							<p class="title">让管理与销售更贴近更轻松</p>
							<p class="title1">来钢贸，企业专属的一体化云端ERP</p>
							<!--<div class="footerFormBox">
								<el-form :model="form" :rules="rules" ref="form">
									<el-row type="flex" :gutter="10" :span="16">
										<div class="form-left">
											<el-col :span="2">
												<el-form-item prop="companyName">
													<el-input placeholder="公司名称" v-model="form.companyName" />
												</el-form-item>
											</el-col>
											<el-col :span="2">
												<el-form-item prop="phone">
													<el-input placeholder="联系电话" v-model="form.phone" />
												</el-form-item>
											</el-col>
											<el-col :span="2">
												<el-form-item prop="linkman">
													<el-input placeholder="联系人" v-model="form.linkman" />
												</el-form-item>
											</el-col>
											<el-col :span="2">
												<el-form-item prop="duty">
													<el-input placeholder="职务" v-model="form.duty" />
												</el-form-item>
											</el-col>
										</div>
										<div class="form-right">
											<el-col :span="2">
												<el-form-item>
													<el-button type="primary" @click="submitForm('form')"><a href="http://app.fengtaoxx.com/steel-user/toRegister">免费试用</a></el-button>
												</el-form-item>
											</el-col>
										</div>
									</el-row>
								</el-form>
							</div>-->
						</div>
						<div class="con-right" style="margin-left: 40px;">
							<img src="../../static/images/wxCode.jpg" />
							<span>关注蜂陶信息公众号</span>
						</div>
					</div>
				</div>
				<!-- 		<div class="bottom">
					<p class="title">友情链接 <span>/ Links</span></p>
					<ul>
						<li><a>进销存系统</a></li>
						<li><a>进销存系统</a></li>
						<li><a>进销存系统</a></li>
						<li><a>进销存系统</a></li>
					</ul>
				</div> -->
			</div>

		</div>
		<div class="footer">
			<div class="con">
				<div class="left">Copyright &copy; 2015 - {{year}} 广州蜂陶信息技术有限公司 版权所有</div>
				<div class="right"><a href="https://beian.miit.gov.cn" target="_blank" style="color:#787878">粤ICP备16034685号</a></div>
			</div>
		</div>
		<div class="serviceBox">
			<ul>
				<li @mouseenter="Enter('Phone')" @mouseleave="Leave('Phone')">
					<img src="../../static/images/icon/serviceIcon1.png" />
					<span>电话咨询</span>
				</li>
				<li @mouseenter="Enter('QQ')" @mouseleave="Leave('QQ')">
					<img src="../../static/images/icon/serviceIcon2.png" />
					<span>QQ咨询</span>
				</li>
				<li @mouseenter="Enter('WX')" @mouseleave="Leave('WX')">
					<img src="../../static/images/icon/serviceIcon3.png" />
					<span>关注微信</span>
				</li>
				<li class="runtop" @click="runTop">
					<img src="../../static/images/icon/serviceIcon4.png" class="top" />
					<span>返回顶部</span>
				</li>
			</ul>
			<div class="showService" v-show="isShow">
				<div class="showPhone" v-show="showPhone" @mouseenter="Enter('Phone')" @mouseleave="Leave('Phone')">
					<div class="showServiceTitle">
						<span><img src="../../static/images/icon/phoneShowIcon.png" /></span>联系方式
					</div>
					<div class="showServiceList">
						<div class="showServiceItem">
							<span>咨询电话</span>
							<span>020-29815512</span>
						</div>
						<div class="showServiceItem">
							<span>李先生</span>
							<span>18922358474</span>
						</div>
						<div class="showServiceItem">
							<span>客服电话</span>
							<span>13824426877</span>
							<span>13725188836</span>
						</div>
						<div class="showServiceItem">
							<span>上班时间</span>
							<span>周一至周五</span>
						</div>
					</div>
				</div>
				<div class="showQQ" v-show="showQQ" @mouseenter="Enter('QQ')" @mouseleave="Leave('QQ')">
					<div class="showServiceTitle">
						<span><img src="../../static/images/icon/qqShowIcon.png" /></span>在线客服
					</div>
					<div class="showServiceList">
						<div class="showServiceItem">
							<a class="IMPanel" style="height:25px;" target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=3365791841&amp;site=qq&amp;menu=yes">
								<img border="0" src="http://wpa.qq.com/pa?p=1:3365791841:4" alt="点击这里给我发消息" align="absmiddle" onerror="$(this).hide();">客服一
							</a>
						</div>
						<div class="showServiceItem">
							<a class="IMPanel" style="height:25px;" target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=419373985&amp;site=qq&amp;menu=yes">
								<img border="0" src="http://wpa.qq.com/pa?p=1:3365791841:4" alt="点击这里给我发消息" align="absmiddle" onerror="$(this).hide();">客服二
							</a>
						</div>
					</div>
				</div>
				<div class="showWX" v-show="showWX" @mouseenter="Enter('WX')" @mouseleave="Leave('WX')">
					<div class="showServiceTitle">
						<span><img src="../../static/images/icon/wxShowIcon.png" /></span>二维码
					</div>
					<div class="showServiceList">
						<div class="showServiceImgItem">
							<img src="../../static/images/wxCode.jpg" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//  import 'swiper/dist/css/swiper.css'
// 
//import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default {
		name: 'home',
		data() {
			var phonePass = (rule, value, callback) => {
				var myreg = /^[1][3-9][0-9]{9}$/;
				if (value === "") {
					callback(new Error('请输入手机号码'));
				} else if (!myreg.test(value)) {
					callback(new Error("请输入正确的手机号码"));
				} else {
					callback(); //重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
				}
			};
			var companyNamePass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error('请输入公司名称'));
				} else {
					callback();
				}
			};
			var linkmanPass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error('请输入联系人'));
				} else {
					callback();
				}
			};
			var dutyPass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error('请输入职务'));
				} else {
					callback();
				}
			};
			return {
				banner:['../../static/images/banner1.png','../../static/images/banner2.png','../../static/images/banner3.png','../../static/images/banner4.png'],
				swiperOption: {
		            pagination: {
			           el: '.swiper-pagination'
			        },	
			        loop: true,
			        navigation: {
				      nextEl: '.swiper-button-next',
				      prevEl: '.swiper-button-prev',
				    },
		        },
				year:2019,
				isShow: false,
				showPhone: false,
				showWX: false,
				showQQ: false,
				intervalId: null,
				conItemNum1:'0',
				conItemNum2:'0',
				conItemNum3:'15345',
				userVo:'',
				form: {
					companyName: '',
					phone: '',
					linkman: '',
					duty: ''

				},
				rules: {
					companyName: [{
						validator: companyNamePass,
						trigger: 'blur'
					}],
					phone: [{
						validator: phonePass,
						trigger: 'blur'
					}],
					linkman: [{
						validator: linkmanPass,
						trigger: 'blur'
					}],
					duty: [{
						validator: dutyPass,
						trigger: 'blur'
					}],
				},
				vipGoodsList:[]
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			runTop() {
				$("body,html").stop().animate({
					scrollTop: 0
				}, 600)
			},
			scollTo(id) {
				var getid = document.getElementById(id);
				var height = getid.offsetTop
				// console.log(height)
				$("body,html").stop().animate({
					scrollTop: height
				}, 600)
			},
			Enter(type) {
				if (this.intervalId) clearTimeout(this.intervalId)
				this.isShow = true
				switch (type) {
					case 'Phone':
						this.showPhone = true
						this.showWX = false
						this.showQQ = false
						break;
					case 'WX':
						this.showWX = true
						this.showPhone = false
						this.showQQ = false
						break;
					case 'QQ':
						this.showQQ = true
						this.showPhone = false
						this.showWX = false
						break;
					default:
						break;
				}

			},
			Leave(type) {
				this.intervalId = setInterval(() => {
					this.isShow = false
					switch (type) {
						case 'Phone':
							this.showPhone = false
							break;
						case 'WX':
							this.showWX = false
							break;
						case 'QQ':
							this.showQQ = false
							break;
						default:
							break;
					}
				}, 600)
			},
			// animateNum(name,num){
			// 	$('.'+name).animate({count:num},{
			// 		duration: 5000, //持续时间  
			// 		step: function() {
			// 			$('.'+name).text(Math.round(this.count));
			// 		}
			// 	})
			// }	
			goPay(e){
				window.location.href = e
				console.log('66')
			},
			showR(){
					
			},
			getCompanyVal(){
				this.axios.post('index/value/getVal',this.qs({key:'CompanyNum'})).then(res =>{
					// console.log(res)
					if(res.data.status == "success"){
						this.conItemNum1 = res.data.data
						$('.con-item-num1').numberAnimate({num:this.conItemNum1,speed:5000,symbol:","})
					}
					// console.log(this.conItemNum1)
				})
			},
			getUserVal(){
				this.axios.post('index/value/getVal',this.qs({key:'UserNum'})).then(res =>{
					console.log(res)
					if(res.data.status == "success"){
						this.conItemNum2 = res.data.data
						$('.con-item-num2').numberAnimate({num:this.conItemNum2,speed:5000,symbol:","})
					}
					// console.log(this.conItemNum2)
				})
			},
			getVipGoodsList(){
				this.axios.post('index/value/getVipGoodsList',null).then(res =>{
					if(res.data.status == "success"){
						this.vipGoodsList = res.data.data
					}
				})
			}
			
		},
		mounted() {
			// this.animateNum('con-item-num1',this.conItemNum1)
			// this.animateNum('con-item-num2',this.conItemNum2)
			// this.animateNum('con-item-num3',this.conItemNum3)
			this.getUserVal()
			this.getCompanyVal()
			this.getVipGoodsList()
//			$('.con-item-num3').numberAnimate({num:this.conItemNum3,speed:5000,symbol:","})
			var date=new Date;
			this.year = date.getFullYear()
//			mobile_home
			if (/(iPhone|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
			    this.$router.push("/mobile_home")
			}else{
				this.$router.push("/")
			}
			// console.log(getCookie("userVo"))
			if(getCookie("userVo")){
				this.userVo = getCookie("userVo")
			}
		}
	}
	function setCookie(cname,cvalue,exdays)
    {
        var d = new Date();
        d.setTime(d.getTime()+(exdays*24*60*60*1000));
        var expires = "expires="+d.toGMTString();
        // console.log(expires)
        // document.cookie = cname + "=" + cvalue + "; " + expires+";domain=.localhost:8080";
        document.cookie = "username=Darren;path=/;domain=app.fengtaoxx.com"
    }
    function getCookie(cname){
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name)==0) { return c.substring(name.length,c.length); }
        }
        return "";
    }
</script>
<style>
	.swiperOption{height: 750px;}
	a {
		padding: 0px !important;
		cursor: pointer;
		color: #000;
	}

	a:hover {
		text-decoration: none;
	}

	.homeHeader {
		background-color: #fff;
		box-sizing: border-box;
		font-size: 18px;
	}

	.homeHeader .container {
		padding: 10px 0;
	}

	.homeHeader .container .navbar {
		margin-bottom: 0px;
	}

	.homeHeader .container .navbar-default {
		background-color: initial;
		border: none;
	}

	.homeHeader .container .navbar-default .container-fluid .navbar-homeHeader {
		height: 62px;
		line-height: 62px;
	}

	.homeHeader .container .navbar-default .container-fluid .navbar-homeHeader .navbar-toggle {
		margin-top: 15px;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul {
		height: 62px;
		display: flex;
		align-items: center;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul li {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul .listTitle {
		margin-right: 20px;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul .btnBox {
		width: 72px;
		box-sizing: initial;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul .phoneBox {
		display: flex;
		justify-content: flex-start;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse .col-lg-8,
	.homeHeader .container .navbar-default .container-fluid .collapse ul .col-lg-1,
	.homeHeader .container .navbar-default .container-fluid .collapse ul .col-lg-3 {
		padding-right: 0px;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul li .Btn {
		width: 72px;
		color: #fff;
		border-radius: 7px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul .btnBox .register-Btn {
		background-color: #f75b47;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul .btnBox .login-Btn {
		background-color: #2cbf61;
	}

	.homeHeader .container .navbar-default .container-fluid .collapse ul .phoneBox .phone {
		font-weight: bold;
		font-size: 20px;
		color: #2797e8;
	}

	.banner .banner-bg {
		/* background: url(../../static/images/banner1.png) no-repeat; */
		/* background-size: 100% auto; */
		/* background-size: cover; */
		height: 750px;
		position: relative;
	}

	.banner .banner-bg img {
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.banner .banner-bg .form-box {
		width: 100%;
		position: absolute;
		top: 540px;
		margin: 0 auto;
	}

	.banner .banner-bg .form-box .el-form .el-row {
		justify-content: center;
		margin-left: 0px !important;
		margin-right: 0px !important;
	}

	.banner .banner-bg .form-box .el-form .el-row .el-col {
		width: 150px;
	}

	.banner .banner-bg .form-box .el-form .el-row .el-form-item .el-button {
		width: 100%;
	}

	.banner .banner-bg .banner-footer {
		width: 100%;
		position: absolute;
		bottom: -36px;
		z-index: 999;
	}

	.banner .banner-bg .banner-footer .container {
		height: 100px;
		width: 1200px;
		background-color: #fff;
		box-shadow: 0 3px 2px #f6f6f6;
		padding: 15px;
		display: flex;
	}

	.banner .banner-bg .banner-footer .container .con-item {
		width: 50%;
		border-right: 1px solid #e3e3e3;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.banner .banner-bg .banner-footer .container .con-item:last-child {
		border-right: none;
	}

	.banner .banner-bg .banner-footer .container .con-item .con-item-num {
		font-size: 36px;
		font-weight: bold;
	}

	.banner .banner-bg .banner-footer .container .con-item .con-item-text {
		font-size: 18px;
		padding-top: 10px;
		padding-left: 10px;
	}

	.banner .banner-bg .banner-footer .container .con-item .add {
		font-size: 18px;
		padding-top: 12px;
		padding-left: 5px;
	}

	.banner .banner-bg .banner-footer .container .con-item .blue {
		color: #109af8;
	}

	.banner .banner-bg .banner-footer .container .con-item .green {
		color: #0ed182;
	}

	.banner .banner-bg .banner-footer .container .con-item .red {
		color: #fe3b20;
	}

	.banner-function {
		height: 530px;
	}

	.banner-function .con {
		width: 1200px;
		margin: 0 auto;
	}

	.banner-function .b-f-con {
		padding-top: 120px;
		padding-bottom: 65px;
	}

	.banner-function .b-f-con .title {
		font-size: 28px;
		text-align: center;
		margin-bottom: 20px;
	}

	.banner-function .b-f-con .title2 {
		font-size: 16px;
		color: #8a8a8a;
		text-align: center;
	}

	.banner-function .b-f-con .functionBox {
		display: flex;
		margin-top: 40px;
	}

	.banner-function .b-f-con .functionBox .function-item {
		width: 25%;
		height: 222px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		margin-left: 80px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.banner-function .b-f-con .functionBox .function-item img {
		width: 115px;
		height: 115px;
		margin-bottom: 20px;
	}

	.banner-function .b-f-con .functionBox .function-item span {
		font-size: 20px;
	}

	.banner-function .b-f-con .functionBox .function-item:first-child {
		margin-left: 0px;
	}

	.banner-do {
		background: url(../../static/images/bannerDoBg.jpg) no-repeat;
		height: 670px;
		width: 100%;
		background-size: cover;
	}

	.banner-do .con {
		width: 1200px;
		margin: 0 auto;
		height: 100%;
		padding-top: 68px;
	}

	.banner-do .con .title {
		font-size: 32px;
		text-align: center;
		margin-bottom: 20px;
		color: #fff;
	}

	.banner-do .con .title2 {
		font-size: 18px;
		color: #fff;
		text-align: center;
	}

	.banner-do .con .doBox {
		display: flex;
		margin-top: 45px;
	}

	.banner-do .con .doBox .do-item {
		width: 33.3%;
		margin-left: 42px;
		height: 400px;
		background-color: #fff;
		border-radius: 10px;
		cursor: pointer;
	}

	.banner-do .con .doBox .do-item .top img {
		width: 100%;
	}

	.banner-do .con .doBox .do-item .bottom {
		padding: 32px 35px 30px 25px;
	}

	.banner-do .con .doBox .do-item .bottom p {
		color: #2d2d2d;
	}

	.banner-do .con .doBox .do-item .bottom .title {
		font-size: 24px;
	}

	.banner-do .con .doBox .do-item .bottom .title2 {
		font-size: 14px;
		text-align: left;
		line-height: 26px;
	}

	.banner-do .con .doBox .do-item:first-child {
		margin-left: 0px;
	}

	.banner-pattern {
		/* height: 1125px; */
	}

	.banner-pattern .con {
		margin: 0 auto;
		width: 1200px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		padding-top: 84px;
	}

	.banner-pattern .con .title {
		font-size: 34px;
		text-align: center;
		margin-bottom: 74px;
	}

	.banner-pattern .con img {
		height: 510px;
	}

	.banner-pattern .con .freeTrialBox {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		width: 232px;
		height: 48px;
		border-radius: 24px;
		border: 1px solid #1d89fc;
		color: #1d89fc;
		margin: 50px auto;
		position: relative;
		cursor: pointer;
	}

	.banner-pattern .con .freeTrialBox a {
		color: #1d89fc;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.banner-pattern .con .freeTrialBox a img {
		position: absolute;
		width: 24px;
		height: 24px;
		right: 25px;
		top: 11px;
	}
  .banner-pattern .con .payUserBox{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
  }
  .banner-pattern .con .payUserBox p{
    font-size: 18px;
    background-color: #df5f1f;
    border-radius: 5px;
    color: #fff;
    text-align: center;
    width: 40%;
    padding: 5px 0;
  }
	.banner-pattern .con .payItemBox {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-bottom: 30px;
	}

	.banner-pattern .con .payItemBox .payItem {
		width: 32%;
		/* margin-left: 100px; */
		height: 210px;
		padding: 0 22px;
		cursor: pointer;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.banner-pattern .con .payItemBox .payItem:nth-child(3n-2) {
		margin-left: 0px;
	}
	.banner-pattern .con .payItemBox .payItem{
		background: url('../../static/images/payItemBg.png') no-repeat center;
		background-size: 100% 100%;
	}
	.banner-pattern .con .payItemBox .payItem:nth-child(3n-2){
		background: url('../../static/images/payItemBg1.png') no-repeat;
		background-size: 100% 100%;
	}
	.banner-pattern .con .payItemBox .payItem:nth-child(3n-1){
		background: url('../../static/images/payItemBg2.png') no-repeat;
		background-size: 100% 100%;
	}
	/* .banner-pattern .con .payItemBox .item1 {
		background: url('../../static/images/payItemBg1.png') no-repeat;
	} */

	.banner-pattern .con .payItemBox .item2 {
		background: url('../../static/images/payItemBg2.png') no-repeat;
	}

	.banner-pattern .con .payItemBox .item3 {
		background: url('../../static/images/payItemBg.png') no-repeat;
	}
	.banner-pattern .con .payItemBox .payItem.item1 p{
		width: 100%;
		text-align: left;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
		height: 68px;
	}
	.banner-pattern .con .payItemBox .payItem .payMessage {
		color: #fff;
		font-size: 16px;
		padding-top: 20px;
		padding-bottom: 10px;
		text-align: center;
	}

	.banner-pattern .con .payItemBox .payItem .payMessage .payPrice {
		font-size: 36px;
		font-weight: bold;
	}

	.banner-pattern .con .payItemBox .payItem .payBtn {
		width: 290px;
		height: 48px;
		border-radius: 24px;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		margin: auto;
	}
    .banner-pattern .con .payItemBox .payItem p{font-size: 16px;text-align: center;color: #fff;margin-top: -10px;margin-bottom: 10px;height: 44px;}
	.banner-pattern .con .payItemBox .payItem .payBtn a {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.banner-pattern .con .payItemBox .payItem .payBtn1 a {
		color: #fd9225;
	}
	.banner-pattern .con .payItemBox .payItem:nth-child(3n-2) .payBtn1 a{
		color: #3ed87b;
	}
	.banner-pattern .con .payItemBox .payItem:nth-child(3n-1) .payBtn1 a{
		color: #9842fa;
	}
	/* .banner-pattern .con .payItemBox .payItem .payBtn1 a {
		color: #3ed87b;
	}

	.banner-pattern .con .payItemBox .payItem .payBtn2 a {
		color: #9842fa;
	} */



	.banner-more {
		background: url(../../static/images/bannerMoreBg.png);
		height: 400px;
		font-size: 18px;
		text-align: center;
		position: relative;
	}

	.banner-more .moreBox {
		width: 196px;
		height: 48px;
		line-height: 48px;
		border-radius: 24px;
		background-color: #fbe92c;
		position: absolute;
		top: 243px;
		left: 370px;
		cursor: pointer;
	}

	.banner-more .moreBox img {
		position: absolute;
		top: 13px;
		right: 20px;
	}

	.banner-port {
		height: 520px;
	}

	.banner-port .con {
		width: 1200px;
		margin: 0 auto;
		height: 100%;
	}

	.banner-port .con .title {
		font-size: 32px;
		text-align: center;
		padding-top: 70px;
		padding-bottom: 20px;
	}

	.banner-port .con .title1 {
		font-size: 18px;
		text-align: center;
		color: #aeaeae;
	}

	.banner-port .con .title1 span {
		margin-left: 20px;
	}

	.banner-port .con .title1 span:first-child {
		margin-left: 0px;
	}

	.banner-port .con .portItemBox {
		display: flex;
		margin-top: 45px;
	}

	.banner-port .con .portItemBox .portItem {
		width: 25%;
		height: 245px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		cursor: pointer;
	}

	.banner-port .con .portItemBox .portItem img {
		width: 192px;
		height: 192px;
	}

	.banner-port .con .portItemBox .portItem span {
		margin-top: 22px;
	}

	.banner-news {
		height: 600px;
		background-color: #f6f6f6;
		padding-bottom: 75px;
		box-sizing: content-box;
	}

	.banner-news .con {
		height: 100%;
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
	}

	.banner-news .con .title {
		font-size: 36px;
		text-align: center;
		padding-top: 60px;
		padding-bottom: 50px;
	}

	.banner-news .con ul {
		display: flex;
		flex-flow: wrap;
		width: 100%;
	}

	.banner-news .con ul li {
		width: 45%;
		margin-left: 120px;
		display: flex;
		flex-direction: row;
		margin-bottom: 60px;
	}

	.banner-news .con ul li:nth-child(2n-1) {
		margin-left: 0px;
	}

	.banner-news .con ul li .left {
		width: 72px;
		margin-right: 25px;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.banner-news .con ul li .right {
		width: 428px;
		cursor: pointer;
	}

	.banner-news .con ul li .left .date {
		font-size: 22px;
	}

	.banner-news .con ul li .left .year {
		font-size: 14px;
		color: #b3b3b3;
		padding-top: 24px;
	}

	.banner-news .con ul li .right .new-title {
		font-size: 18px;
		margin-bottom: 25px;
		padding-top: 4px;
	}

	.banner-news .con ul li .right .new-title span {
		margin-right: 12px;
	}

	.banner-news .con ul li .right .new-title span img {
		width: 25px;
		height: 25px;
	}

	.banner-news .con ul li .right .new-content {
		font-size: 15px;
		color: #969696;
		height: 44px;
		overflow: hidden;
		line-height: 25px;
	}

	.footer-we {
		height: 430px;
		background-color: #2c2c2c;
	}

	.footer-we .con {
		height: 100%;
		width: 1200px;
		margin: 0 auto;
	}

	.footer-we .con .top {
		display: flex;
		padding-top: 75px;
	}

	.footer-we .con .top .left {
		width: 50%;
		height: 150px;
		padding-right: 70px;

	}

	.footer-we .con .top .left .title {
		font-size: 24px;
		color: #fff;
		padding-bottom: 5px;
	}

	.footer-we .con .top .left .title span {
		font-size: 15px;
		color: #787878;
	}

	.footer-we .con .top .left .content {
		font-size: 14px;
		color: #787878;
		line-height: 30px;
		padding-bottom: 10px;
	}

	.footer-we .con .top .right {
		width: 50%;
		padding-left: 70px;
		display: flex;
		border-left: 1px solid #3a3a3a;
	}

	.footer-we .con .top .right .con-left .title {
		font-size: 26px;
		color: #fff;
		padding-bottom: 16px;
	}

	.footer-we .con .top .right .con-left .title1 {
		font-size: 16px;
		color: #fff;
	}

	.footer-we .con .top .right .con-left .footerFormBox {
		width: 420px;
		display: flex;
		flex-flow: wrap;
		padding-top: 36px;
	}

	.footer-we .con .top .right .con-left .footerFormBox .form-left {
		width: 300px;
	}

	.footer-we .con .top .right .con-left .footerFormBox .form-right {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.footer-we .con .top .right .con-left .footerFormBox .el-col {
		width: 150px;
	}

	.footer-we .con .top .right .con-left .footerFormBox .form-right .el-col {
		width: 110px;
	}

	.footer-we .con .top .right .con-right {
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.footer-we .con .top .right .con-right img {
		width: 120px;
		height: 120px;
	}

	.footer-we .con .top .right .con-right span {
		font-size: 13px;
		color: #787878;
		padding-top: 10px;
	}

	.footer-we .con .bottom .title {
		font-size: 24px;
		color: #fff;
		padding-bottom: 32px;
	}

	.footer-we .con .bottom .title span {
		font-size: 15px;
		color: #787878;
	}

	.footer-we .con .bottom ul {
		display: flex;
	}

	.footer-we .con .bottom ul li {
		margin-left: 45px;
	}

	.footer-we .con .bottom ul li a {
		text-decoration: none;
		cursor: pointer;
	}

	.footer-we .con .bottom ul li:first-child {
		margin-left: 0px;
	}

	.footer {
		height: 45px;
		background-color: #1f1f1f;
	}

	.footer .con {
		width: 1200px;
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #666;
		font-size: 14px;
		margin: 0 auto;
	}

	.serviceBox {
		width: 100px;
		height: 308px;
		background: url(../../static/images/serviceBg.png) no-repeat;
		position: fixed;
		top: 500px;
		right: 10px;
		z-index: 999;
	}

	.serviceBox ul {
		padding: 0 10px;
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.serviceBox ul li {
		height: 25%;
		width: 100%;
		border-bottom: 1px dashed #68d5ff;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

	}

	.serviceBox ul li img {
		width: 25px;
		height: 25px;
	}

	.serviceBox ul li .top {
		width: 30px;
		height: 16px;
	}

	.serviceBox ul li span {
		margin-top: 10px;
	}

	.serviceBox ul li:last-child {
		border-bottom: none;
	}

	.serviceBox .showService {
		background: #fff;
		border: 1px solid #efefef;
		width: 166px;
		height: auto;
		position: absolute;
		right: 110px;
		bottom: 0;
		padding: 10px;
	}

	.serviceBox .showService .showServiceTitle {
		height: 30px;
		display: flex;
		align-items: center;
		font-size: 14px;
		padding-left: 10px;
	}

	.serviceBox .showService .showServiceTitle span {
		padding-right: 10px;
	}

	.serviceBox .showService .showServiceTitle span img {
		width: 32px;
		height: 32px;
		padding-bottom: 5px;
		box-sizing: content-box;
	}

	.serviceBox .showService .showServiceList .showServiceItem {
		display: flex;
		flex-direction: column;
		padding: 10px 10px 0 10px;
		font-size: 14px;
		color: #666;
	}

	.serviceBox .showService .showServiceList .showServiceItem span {
		padding-top: 10px;
	}

	.serviceBox .showService .showServiceList .showServiceItem a {
		font-size: 14px;
		color: #333;
		text-decoration: initial;
	}

	.serviceBox .showService .showServiceList .showServiceItem a img {
		height: 14px;
		margin-right: 10px;
	}

	.serviceBox .showService .showServiceList .showServiceImgItem {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.serviceBox .showService .showServiceList .showServiceImgItem img {
		width: 128px;
		height: 128px;
	}
	
	@media all and (max-width:1200px) {
		.swiperOption{
			width: 100%;
			height: 650px;
		}
		.banner{
			width: 100%;
		}
		.banner .banner-bg .banner-footer{
			padding: 0 20px;
			bottom: 52px;
		}
		.banner .banner-bg .banner-footer .container{
			width: 100%;
		}
		.banner-function{
			height: 100%;
		}
		.banner-function .con{
			width: 100%;
			padding: 0 20px;
		}
		.banner-function .b-f-con{
			padding-top: 0px;
		}
		.banner-function .b-f-con .functionBox{
		}
		.banner-function .b-f-con .functionBox .function-item span{
			text-align: center;
		}
		.banner-do{
			height: inherit;
			padding-bottom: 20px;
		}
		.banner-do .con{
			width: 100%;
		}
		.banner-do .con .doBox{
			padding: 0 20px;
		}
		.banner-do .con .doBox .do-item{
			height: inherit;
		}
		.banner-pattern{
			height: 100%;
		}
		.banner-pattern .con img {
			height: 400px;
		}
		.banner-pattern .con {
			width: 100%;
		}
		.banner-pattern .con .payItemBox{
			display: flex;
			justify-content: space-around;
			padding: 0 20px;
			flex-flow: wrap;
		}
		.banner-pattern .con .payItemBox .payItem{
			margin: 0px 0px 20px 0px;
			width: 290px;
			box-sizing: content-box;
		}
		.banner-more{
			background-size: 100% 100%;
			height: 200px;
		}
		.banner-port .con{
			width: 100%;
			padding: 0 20px;
		}
		.footer-we .con {
			width: 100%;
			padding: 0 20px;
		}
		.footer .con{
			width: 100%;
			padding: 0 20px;
		}
		.banner-port .con .portItemBox .portItem img{
			width: 150px;
			height: 150px;
		}
	}
	.portItemOnimg2{
		display: none;
	}
	.portItemOn:hover img:nth-child(1){
		display: none;
	}
	.portItemOn:hover img:nth-child(2){
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/home.vue